import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createModule, getModuleList } from "reduxStore/action/moduleActions";
import { removeModalClass } from "utils/modalHandler";
import strings from "translate/language";
import { errorToast, successToast } from "utils/httpClient";
import { convertToSlug, handleListResponse, seo, isEmpty } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import TableDataNotFound from "component/TableDataNotFound";
import Button from "../../component/Button";
import usePermission from "utils/usePermission";

const Module = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    module_title: "",
    parent_id: "",
    search_parent_id: "",
    search_name: "",
    sequence: "",
  });
  const [formVaild, setFormVaild] = useState(false);
  const [SearchType, setSearchType] = useState(false);
  const [moduleData, setModuleData] = useState([]);
  const [parentName, setParentName] = useState([]);

  const dispatch = useDispatch();

  const modulesSelector = useSelector((state) => state.modules) || [];

  const { create, edit } = usePermission({
    create: "add_module",
    edit: "edit_module",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const filterDetail = () => {
    dispatch(
      getModuleList({
        search_parent_id: form.search_parent_id,
        search_name: form.search_name,
      })
    );
  };
  const filterReset = () => {
    setForm({
      search_parent_id: "",
      search_name: "",
    });
    dispatch(getModuleList());
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    if (!form?.update && e.target.name === "module_title") {
      nextFormState.slug = convertToSlug(e.target.value);
    }
    setForm(nextFormState);
  };

  useEffect(() => {
    dispatch(getModuleList());
  }, []);
  useEffect(() => {
    if (modulesSelector?.create === true) {
      if (modulesSelector?.response?.status === 200) {
        setForm({ module_title: "", parent_id: "", slug: "", sequence: "" });
        dispatch(getModuleList());
        successToast(modulesSelector?.response?.message);
      } else {
        errorToast(modulesSelector?.response?.message);
      }
    } else {
      if (modulesSelector?.response?.status === 200) {
        setModuleData(handleListResponse(modulesSelector?.response?.data));
        if (isEmpty(form.search_parent_id) && isEmpty(form.search_name)) {
          setParentName(handleListResponse(modulesSelector?.response?.data));
        }
      } else {
        setModuleData([]);
        // errorToast(moduleData.response.message);
      }
    }
  }, [modulesSelector]);

  const getModule = (id = "") => {
    setFormVaild(false);
    const filtered = moduleData.filter((i) => i._id === id);
    if (filtered.length) {
      setForm({
        module_id: id,
        module_title: filtered[0].module_title,
        parent_id: filtered[0].parent_id,
        slug: filtered[0].slug,
        sequence: filtered[0].sequence,
        update: true,
      });
    }
    document.getElementById("submitmodal").textContent = "Update";
  };
  const handleSubmit = () => {
    if (form.module_title === "") {
      setFormVaild(true);

      return true;
    } else {
      removeModalClass("exampleModal");
      setFormVaild(false);
      dispatch(createModule(form));
    }
  };
  useEffect(() => {
    seo({
      title: "Module Listing",
      metaDescription: "Module listing",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      {/*add_module_start */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.moduleName}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            {form.parent_id !== null && (
              <div className="modal-body">
                <label htmlFor="exampleFormControlSelect9">
                  {strings.parentOptional}
                </label>

                <select
                  className="form-control digits"
                  id="exampleFormControlSelect9"
                  name="parent_id"
                  value={form.parent_id}
                  onChange={handleInputField}
                >
                  <option defaultValue={true}>{strings.selectParent}</option>
                  {parentName.map((item, index) =>
                    item.parent_id === null ? (
                      <option key={index} value={item._id}>
                        {item.module_title}
                      </option>
                    ) : null
                  )}
                </select>
              </div>
            )}
            <div className="modal-body">
              <label htmlFor="exampleFormControlSelect9">
                {strings.moduleName}
                <span className="required-field"></span>
              </label>
              <input
                className="form-control"
                id="exampleFormControlFirstName"
                autoComplete="off"
                type="text"
                placeholder={strings.moduleName}
                name="module_title"
                value={form.module_title}
                onChange={handleInputField}
              />
              {formVaild && (
                <span style={{ color: "red" }}>
                  {strings.modulenameisrequired}
                </span>
              )}
            </div>
            <div className="modal-body">
              <label htmlFor="exampleFormControlSelect9">
                {strings.sequence}
                <span className="required-field"></span>
              </label>
              <input
                className="form-control"
                id="exampleFormControlFirstName"
                type="number"
                autoComplete="off"
                placeholder={strings.sequence}
                name="sequence"
                value={form.sequence}
                onChange={handleInputField}
              />
              {formVaild && (
                <span style={{ color: "red" }}>
                  {strings.sequenceisrequired}
                </span>
              )}
            </div>
            <div className="modal-body">
              <label htmlFor="exampleFormControlSelect9"> {strings.slug}</label>
              <input
                className="form-control"
                id="exampleFormControlFirstName"
                type="text"
                placeholder={strings.slug}
                name="slug"
                value={form.slug}
                readOnly={true}
                onChange={handleInputField}
              />
            </div>

            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <Button
                className="btn btn-dark"
                dataDismiss="modal"
                label={strings.back}
              ></Button>
              <Button
                id="submitmodal"
                onClick={() => handleSubmit()}
                label={strings.submit}
              ></Button>
            </div>
          </div>
        </div>
      </div>
      {/* add_module_end */}
      <Breadcrumb title={strings.module} titleactive={strings.moduleListing} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">
                            {" "}
                            {strings.searchmoduleName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="search_name"
                              value={form.search_name}
                              onChange={handleInputField}
                              placeholder={strings.searchName}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchparentOptional}
                          </span>
                          <select
                            className="form-control digits"
                            id="exampleFormControlSelect9"
                            name="search_parent_id"
                            value={form.search_parent_id}
                            onChange={handleInputField}
                          >
                            <option defaultValue={null}>
                              {strings.selectParent}
                            </option>
                            {parentName.map((item, index) =>
                              item.parent_id === null ? (
                                <option key={index} value={item._id}>
                                  {item.module_title}
                                </option>
                              ) : null
                            )}
                          </select>
                        </div>
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <Button
                              className="btn btn-warning mr-4"
                              onClick={filterDetail}
                              label={strings.search}
                            ></Button>
                            <Button
                              className="btn btn-dark"
                              onClick={filterReset}
                              label={strings.reset}
                            ></Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {create && (
              <div className="row pt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <Button
                      dataToggle="modal"
                      dataOriginalTitle="test"
                      dataTarget="#exampleModal"
                      onClick={() => {
                        setForm({
                          module_title: "",
                          parent_id: "",
                          slug: "",
                          sequence: "",
                        });
                        document.getElementById("submitmodal").textContent =
                          "Submit";
                      }}
                      label={strings.addNewModule}
                    ></Button>
                  </div>
                </div>
                <div className="col-md-6 "></div>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfModule}</h5>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.modules}</th>
                          <th scope="col">{strings.parent}</th>
                          <th scope="col">{strings.sequence}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {moduleData
                          .sort((a, b) => a.sequence - b.sequence)
                          .map((item, index) => (
                            <tr key={index}>
                              <td>{item.module_title}</td>
                              <td>{item.parent_name ? item.parent_name : "-"}</td>
                              <td>{item.sequence ? item.sequence : "-"}</td>
                              {edit && (
                                <td>
                                  <Button
                                    className="btn btn-dark"
                                    dataToggle="modal"
                                    dataOriginalTitle="test"
                                    dataTarget="#exampleModal"
                                    onClick={() => getModule(item._id)}
                                    label={strings.edit}
                                  ></Button>
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <TableDataNotFound data={moduleData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Module;
